import React from 'react';
import Appstore from '../../assets/svg/ios.svg';
import Close from '../../assets/svg/menu-close.svg';
import DownArrow from '../../assets/svg/arrow-head.svg';
import BlackArrow from '../../assets/svg/black-down-arrow.svg';
import Menu from '../../assets/svg/menu-icon.svg';
import Logo from '../../assets/svg/logo.svg';
import GooglePlayStore from '../../assets/svg/google-play-store.svg';
import Search from '../../assets/svg/search-icon.svg';
import Sports from '../../assets/svg/sports.svg';
import YoutubeIcon from '../../assets/svg/youtube-icon.svg';
import Facebook from '../../assets/svg/facebook.svg';
import Instagram from '../../assets/svg/instagram.svg';
import Tiktok from '../../assets/svg/tiktok.svg';
import Twitter from '../../assets/svg/twitter.svg';
import Youtube from '../../assets/svg/youtube.svg';
import LinkedIn from '../../assets/svg/linkedin.svg';
import RightArrow from '../../assets/svg/right-arrow.svg';
import ModalClose from '../../assets/svg/modal-close.svg';
import InstagramIcon from '../../assets/svg/instagram-icon.svg';
import SliderRightArrow from '../../assets/svg/slider-right-arrow.svg';
import SliderLeftArrow from '../../assets/svg/slider-left-arrow.svg';
import BlackNextArrow from '../../assets/svg/black-next-arrow.svg';
import BlackPrevArrow from '../../assets/svg/black-prev-arrow.svg';
import WhiteNextArrow from '../../assets/svg/white-next-arrow.svg';
import WhitePrevArrow from '../../assets/svg/white-prev-arrow.svg';
import SearchIcon from '../../assets/svg/home-search-icon.svg';
import RectangleEmpty from '../../assets/svg/rectangle-empty.svg';
import RectangleChecked from '../../assets/svg/rectangle-checked.svg';
import PaginationRightArrow from '../../assets/svg/pagination-right-arrow.svg';
import PaginationLeftArrow from '../../assets/svg/pagination-left-arrow.svg';
import Calendar from '../../assets/svg/calendar.svg';
import PlusIcon from '../../assets/svg/plus-icon.svg';
import MinusIcon from '../../assets/svg/minus-icon.svg';
import Football from '../../assets/svg/football.svg';
import Basketball from '../../assets/svg/basketball.svg';
import Padel from '../../assets/svg/padle.svg';
import TableTennis from '../../assets/svg/table-tennis.svg';
import Volleyball from '../../assets/svg/volleyball.svg';
import Tennis from '../../assets/svg/tennis.svg';
import Badminton from '../../assets/svg/badminton.svg';
import Cricket from '../../assets/svg/cricket.svg';
import Pickleball from '../../assets/svg/pickleball.svg';
import IndoorCycling from '../../assets/svg/indoor-cycling.svg';
import Teqball from '../../assets/svg/teqball.svg';
import Phone from '../../assets/svg/icon-phone.svg';
import Email from '../../assets/svg/icon-email.svg';

export default function Icons({ icon, className }) {
  const components = [
    { comp: <Appstore className={className} />, icon: 'ios' },
    { comp: <Close className={className} />, icon: 'close' },
    { comp: <DownArrow className={className} />, icon: 'arrow-head' },
    { comp: <BlackArrow className={className} />, icon: 'black-down-arrow' },
    { comp: <Logo className={className} />, icon: 'logo' },
    { comp: <GooglePlayStore className={className} />, icon: 'google-play-store' },
    { comp: <Menu className={className} />, icon: 'menu' },
    { comp: <Search className={className} />, icon: 'search' },
    { comp: <Sports className={className} />, icon: 'sports' },
    { comp: <YoutubeIcon className={className} />, icon: 'youtube-icon' },
    { comp: <Facebook className={className} />, icon: 'facebook' },
    { comp: <Instagram className={className} />, icon: 'instagram' },
    { comp: <Twitter className={className} />, icon: 'twitter' },
    { comp: <Tiktok className={className} />, icon: 'tiktok' },
    { comp: <Youtube className={className} />, icon: 'youtube' },
    { comp: <LinkedIn className={className} />, icon: 'linkedin' },
    { comp: <RightArrow className={className} />, icon: 'right-arrow' },
    { comp: <ModalClose className={className} />, icon: 'modal-close' },
    { comp: <InstagramIcon className={className} />, icon: 'instagram-icon' },
    { comp: <SliderRightArrow className={className} />, icon: 'slider-right-arrow' },
    { comp: <SliderLeftArrow className={className} />, icon: 'slider-left-arrow' },
    { comp: <PaginationRightArrow className={className} />, icon: 'pagination-right-arrow' },
    { comp: <PaginationLeftArrow className={className} />, icon: 'pagination-left-arrow' },
    { comp: <SearchIcon className={className} />, icon: 'home-search-icon' },
    { comp: <RectangleEmpty className={className} />, icon: 'rectangle-empty' },
    { comp: <RectangleChecked className={className} />, icon: 'rectangle-checked' },
    { comp: <Calendar className={className} />, icon: 'calendar' },
    { comp: <BlackNextArrow className={className} />, icon: 'black-next-arrow' },
    { comp: <BlackPrevArrow className={className} />, icon: 'black-prev-arrow' },
    { comp: <WhiteNextArrow className={className} />, icon: 'white-next-arrow' },
    { comp: <WhitePrevArrow className={className} />, icon: 'white-prev-arrow' },
    { comp: <PlusIcon className={className} />, icon: 'plus' },
    { comp: <MinusIcon className={className} />, icon: 'minus' },
    { comp: <Football className={className} />, icon: 'football' },
    { comp: <Basketball className={className} />, icon: 'basketball' },
    { comp: <Padel className={className} />, icon: 'padel' },
    { comp: <TableTennis className={className} />, icon: 'table-tennis' },
    { comp: <Volleyball className={className} />, icon: 'volleyball' },
    { comp: <Tennis className={className} />, icon: 'tennis' },
    { comp: <Cricket className={className} />, icon: 'cricket' },
    { comp: <Badminton className={className} />, icon: 'badminton' },
    { comp: <Pickleball className={className} />, icon: 'pickleball' },
    { comp: <IndoorCycling className={className} />, icon: 'indoor-cycling' },
    { comp: <Teqball className={className} />, icon: 'teqball' },
    { comp: <Phone className={className} />, icon: 'phone' },
    { comp: <Email className={className} />, icon: 'email' },
  ];

  return icon && components.some((el) => el.icon === icon)
    ? components.find((el) => el.icon === icon).comp
    : null;
}
